"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Restriction = exports.SampledData = exports.Output = exports.Input = exports.Range = exports.Ratio = exports.Component = exports.Timing = exports.Activity = exports.Participant = exports.ReferenceRange = exports.Context = exports.ContextRelated = exports.Annotation = exports.FHIROption = exports.Answer = exports.EnableWhen = exports.Network = exports.Payload = exports.Identifier = exports.Reference = exports.ContactDetail = exports.ContactPoint = exports.Contact = exports.PatientCommunication = exports.Link = exports.Content = exports.Qualification = exports.Attachment = exports.VaccinationProtocol = exports.ImmunizationReaction = exports.ImmunizationExplaination = exports.PractitionerForImmunization = exports.UsageContext = exports.Quantity = exports.Period = exports.CodeableConcept = exports.Meta = exports.Address = exports.Extension = exports.HumanName = exports.DoseCoding = exports.Coding = exports.Code = exports.Narrative = exports.Resource = exports.DomainResource = exports.Id = exports.BackboneElement = exports.FHIRElement = void 0;
exports.Schedule = exports.HealthcareService = exports.Bundle = exports.AuditEvent = exports.CommunicationRequest = exports.Immunization = exports.Observation = exports.Device = exports.Practitioner = exports.PractitionerRole = exports.ProcedureRequest = exports.Task = exports.Communication = exports.CarePlan = exports.EpisodeOfCare = exports.CareTeam = exports.CareTeamParticipant = exports.Encounter = exports.ProcessRequest = exports.Account = exports.Location = exports.Organization = exports.AppointmentResponse = exports.Appointment = exports.DocumentReference = exports.Patient = exports.Questionnaire = exports.QuestionnaireResponse = exports.Udi = exports.Entity = exports.EntityDetail = exports.Source = exports.Agent = exports.Item = exports.QuestionnaireResponseItem = exports.Requester = exports.Position = exports.ActivityDetail = exports.BundleEntry = exports.BundleResponse = exports.BundleRequest = exports.Search = exports.BundleSignature = exports.BundleLink = exports.NotAvailable = exports.AvailableTime = void 0;
/* This is base class from which other elements are derived */
var FHIRElement = /** @class */ (function () {
    function FHIRElement() {
    }
    return FHIRElement;
}());
exports.FHIRElement = FHIRElement;
var BackboneElement = /** @class */ (function (_super) {
    __extends(BackboneElement, _super);
    function BackboneElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BackboneElement;
}(FHIRElement));
exports.BackboneElement = BackboneElement;
/* FHIR classes used in resources */
var Id = /** @class */ (function () {
    function Id(input) {
        var re = new RegExp('[A-Za-z0-9\\-\\.]{1,64}');
        if (re.test(input)) {
            this.id = input;
        }
        else {
            throw new RangeError('Not a valid Id string - must match reg exp [A-Za-z0-9\\-\\.]{1,64} Was provided: ' + input);
        }
    }
    return Id;
}());
exports.Id = Id;
var DomainResource = /** @class */ (function () {
    function DomainResource() {
    }
    return DomainResource;
}());
exports.DomainResource = DomainResource;
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Resource;
}(DomainResource));
exports.Resource = Resource;
var Narrative = /** @class */ (function () {
    function Narrative() {
    }
    return Narrative;
}());
exports.Narrative = Narrative;
var Code = /** @class */ (function (_super) {
    __extends(Code, _super);
    function Code(input) {
        var _this = _super.call(this) || this;
        _this.codeRE = new RegExp('[^\\s]+([\\s]?[^\\s]+)*');
        _this.setCode(input);
        return _this;
    }
    Code.prototype.setCode = function (input) {
        if (this.codeRE.test(input)) {
            this._code = input;
        }
        else {
            throw new RangeError('Not a valid Id string - must match reg exp [^\\s]+([\\s]?[^\\s]+)* Was provided: ' + input);
        }
    };
    Code.prototype.getcode = function () {
        return this._code;
    };
    Code.prototype.setcode = function (input) {
        this.setCode(input);
    };
    Code.prototype.toString = function () {
        return this._code;
    };
    return Code;
}(FHIRElement));
exports.Code = Code;
var Coding = /** @class */ (function (_super) {
    __extends(Coding, _super);
    function Coding() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Coding;
}(FHIRElement));
exports.Coding = Coding;
var DoseCoding = /** @class */ (function (_super) {
    __extends(DoseCoding, _super);
    function DoseCoding() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DoseCoding;
}(FHIRElement));
exports.DoseCoding = DoseCoding;
var HumanName = /** @class */ (function (_super) {
    __extends(HumanName, _super);
    function HumanName() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HumanName;
}(FHIRElement));
exports.HumanName = HumanName;
var Extension = /** @class */ (function () {
    function Extension() {
    }
    return Extension;
}());
exports.Extension = Extension;
var Address = /** @class */ (function (_super) {
    __extends(Address, _super);
    function Address() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Address;
}(FHIRElement));
exports.Address = Address;
var Meta = /** @class */ (function (_super) {
    __extends(Meta, _super);
    function Meta() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Meta;
}(FHIRElement));
exports.Meta = Meta;
var CodeableConcept = /** @class */ (function (_super) {
    __extends(CodeableConcept, _super);
    function CodeableConcept() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CodeableConcept;
}(FHIRElement));
exports.CodeableConcept = CodeableConcept;
var Period = /** @class */ (function (_super) {
    __extends(Period, _super);
    function Period() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Period;
}(FHIRElement));
exports.Period = Period;
var Quantity = /** @class */ (function (_super) {
    __extends(Quantity, _super);
    function Quantity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Quantity;
}(FHIRElement));
exports.Quantity = Quantity;
var UsageContext = /** @class */ (function (_super) {
    __extends(UsageContext, _super);
    function UsageContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsageContext.prototype.setvalueCodeableConcept = function (value) {
        this.value = value;
    };
    UsageContext.prototype.setvalueQuantity = function (value) {
        this.value = value;
    };
    UsageContext.prototype.setvalueRange = function (value) {
        this.value = value;
    };
    return UsageContext;
}(FHIRElement));
exports.UsageContext = UsageContext;
var PractitionerForImmunization = /** @class */ (function (_super) {
    __extends(PractitionerForImmunization, _super);
    function PractitionerForImmunization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PractitionerForImmunization;
}(BackboneElement));
exports.PractitionerForImmunization = PractitionerForImmunization;
var ImmunizationExplaination = /** @class */ (function (_super) {
    __extends(ImmunizationExplaination, _super);
    function ImmunizationExplaination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ImmunizationExplaination;
}(BackboneElement));
exports.ImmunizationExplaination = ImmunizationExplaination;
var ImmunizationReaction = /** @class */ (function (_super) {
    __extends(ImmunizationReaction, _super);
    function ImmunizationReaction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ImmunizationReaction;
}(BackboneElement));
exports.ImmunizationReaction = ImmunizationReaction;
var VaccinationProtocol = /** @class */ (function (_super) {
    __extends(VaccinationProtocol, _super);
    function VaccinationProtocol() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return VaccinationProtocol;
}(BackboneElement));
exports.VaccinationProtocol = VaccinationProtocol;
var Attachment = /** @class */ (function (_super) {
    __extends(Attachment, _super);
    function Attachment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Attachment;
}(FHIRElement));
exports.Attachment = Attachment;
var Qualification = /** @class */ (function (_super) {
    __extends(Qualification, _super);
    function Qualification() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Qualification;
}(BackboneElement));
exports.Qualification = Qualification;
var Content = /** @class */ (function (_super) {
    __extends(Content, _super);
    function Content() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Content;
}(BackboneElement));
exports.Content = Content;
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Link;
}(BackboneElement));
exports.Link = Link;
var PatientCommunication = /** @class */ (function (_super) {
    __extends(PatientCommunication, _super);
    function PatientCommunication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PatientCommunication;
}(BackboneElement));
exports.PatientCommunication = PatientCommunication;
var Contact = /** @class */ (function (_super) {
    __extends(Contact, _super);
    function Contact() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Contact;
}(BackboneElement));
exports.Contact = Contact;
var ContactPoint = /** @class */ (function (_super) {
    __extends(ContactPoint, _super);
    function ContactPoint() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ContactPoint;
}(FHIRElement));
exports.ContactPoint = ContactPoint;
var ContactDetail = /** @class */ (function (_super) {
    __extends(ContactDetail, _super);
    function ContactDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ContactDetail;
}(FHIRElement));
exports.ContactDetail = ContactDetail;
var Related = /** @class */ (function (_super) {
    __extends(Related, _super);
    function Related() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Related;
}(BackboneElement));
var Reference = /** @class */ (function (_super) {
    __extends(Reference, _super);
    function Reference() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Reference;
}(FHIRElement));
exports.Reference = Reference;
var Identifier = /** @class */ (function (_super) {
    __extends(Identifier, _super);
    function Identifier() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Identifier;
}(FHIRElement));
exports.Identifier = Identifier;
var Payload = /** @class */ (function (_super) {
    __extends(Payload, _super);
    function Payload() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Payload;
}(BackboneElement));
exports.Payload = Payload;
var Network = /** @class */ (function (_super) {
    __extends(Network, _super);
    function Network() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Network;
}(BackboneElement));
exports.Network = Network;
var EnableWhen = /** @class */ (function (_super) {
    __extends(EnableWhen, _super);
    function EnableWhen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EnableWhen.prototype.setanswerBoolean = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerInteger = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerDate = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerdateTime = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerTime = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerUri = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerAttachment = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerCoding = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerQuantity = function (answer) {
        this.answer = answer;
    };
    EnableWhen.prototype.setanswerReference = function (answer) {
        this.answer = answer;
    };
    return EnableWhen;
}(BackboneElement));
exports.EnableWhen = EnableWhen;
var Answer = /** @class */ (function (_super) {
    __extends(Answer, _super);
    function Answer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Answer;
}(BackboneElement));
exports.Answer = Answer;
var FHIROption = /** @class */ (function (_super) {
    __extends(FHIROption, _super);
    function FHIROption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FHIROption.prototype.setvalueDate = function (value) {
        this.value = value;
    };
    FHIROption.prototype.setvalueTime = function (value) {
        this.value = value;
    };
    FHIROption.prototype.setvalueString = function (value) {
        this.value = value;
    };
    FHIROption.prototype.setvalueCoding = function (value) {
        this.value = value;
    };
    return FHIROption;
}(BackboneElement));
exports.FHIROption = FHIROption;
var Annotation = /** @class */ (function (_super) {
    __extends(Annotation, _super);
    function Annotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Annotation;
}(FHIRElement));
exports.Annotation = Annotation;
var ContextRelated = /** @class */ (function (_super) {
    __extends(ContextRelated, _super);
    function ContextRelated() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ContextRelated;
}(BackboneElement));
exports.ContextRelated = ContextRelated;
var Context = /** @class */ (function (_super) {
    __extends(Context, _super);
    function Context() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Context;
}(BackboneElement));
exports.Context = Context;
var ReferenceRange = /** @class */ (function (_super) {
    __extends(ReferenceRange, _super);
    function ReferenceRange() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ReferenceRange;
}(BackboneElement));
exports.ReferenceRange = ReferenceRange;
var Participant = /** @class */ (function (_super) {
    __extends(Participant, _super);
    function Participant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Participant;
}(BackboneElement));
exports.Participant = Participant;
var Activity = /** @class */ (function (_super) {
    __extends(Activity, _super);
    function Activity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Activity;
}(BackboneElement));
exports.Activity = Activity;
var Timing = /** @class */ (function (_super) {
    __extends(Timing, _super);
    function Timing() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Timing;
}(FHIRElement));
exports.Timing = Timing;
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Component;
}(BackboneElement));
exports.Component = Component;
var Ratio = /** @class */ (function (_super) {
    __extends(Ratio, _super);
    function Ratio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Ratio;
}(FHIRElement));
exports.Ratio = Ratio;
var Range = /** @class */ (function (_super) {
    __extends(Range, _super);
    function Range() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Range;
}(FHIRElement));
exports.Range = Range;
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Input;
}(BackboneElement));
exports.Input = Input;
var Output = /** @class */ (function (_super) {
    __extends(Output, _super);
    function Output() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Output;
}(BackboneElement));
exports.Output = Output;
var SampledData = /** @class */ (function (_super) {
    __extends(SampledData, _super);
    function SampledData() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SampledData;
}(FHIRElement));
exports.SampledData = SampledData;
var Restriction = /** @class */ (function (_super) {
    __extends(Restriction, _super);
    function Restriction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Restriction;
}(BackboneElement));
exports.Restriction = Restriction;
var AvailableTime = /** @class */ (function (_super) {
    __extends(AvailableTime, _super);
    function AvailableTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AvailableTime;
}(BackboneElement));
exports.AvailableTime = AvailableTime;
var NotAvailable = /** @class */ (function (_super) {
    __extends(NotAvailable, _super);
    function NotAvailable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NotAvailable;
}(BackboneElement));
exports.NotAvailable = NotAvailable;
var BundleLink = /** @class */ (function (_super) {
    __extends(BundleLink, _super);
    function BundleLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BundleLink;
}(BackboneElement));
exports.BundleLink = BundleLink;
var BundleSignature = /** @class */ (function (_super) {
    __extends(BundleSignature, _super);
    function BundleSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BundleSignature;
}(FHIRElement));
exports.BundleSignature = BundleSignature;
var Search = /** @class */ (function (_super) {
    __extends(Search, _super);
    function Search() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Search;
}(BackboneElement));
exports.Search = Search;
var BundleRequest = /** @class */ (function (_super) {
    __extends(BundleRequest, _super);
    function BundleRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BundleRequest;
}(BackboneElement));
exports.BundleRequest = BundleRequest;
var BundleResponse = /** @class */ (function (_super) {
    __extends(BundleResponse, _super);
    function BundleResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BundleResponse;
}(BackboneElement));
exports.BundleResponse = BundleResponse;
var BundleEntry = /** @class */ (function (_super) {
    __extends(BundleEntry, _super);
    function BundleEntry() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BundleEntry;
}(BackboneElement));
exports.BundleEntry = BundleEntry;
var ActivityDetail = /** @class */ (function (_super) {
    __extends(ActivityDetail, _super);
    function ActivityDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ActivityDetail;
}(BackboneElement));
exports.ActivityDetail = ActivityDetail;
var Position = /** @class */ (function (_super) {
    __extends(Position, _super);
    function Position() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Position;
}(BackboneElement));
exports.Position = Position;
var Requester = /** @class */ (function (_super) {
    __extends(Requester, _super);
    function Requester() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Requester;
}(BackboneElement));
exports.Requester = Requester;
var QuestionnaireResponseItem = /** @class */ (function (_super) {
    __extends(QuestionnaireResponseItem, _super);
    function QuestionnaireResponseItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QuestionnaireResponseItem;
}(BackboneElement));
exports.QuestionnaireResponseItem = QuestionnaireResponseItem;
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Item;
}(BackboneElement));
exports.Item = Item;
var Agent = /** @class */ (function (_super) {
    __extends(Agent, _super);
    function Agent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Agent;
}(BackboneElement));
exports.Agent = Agent;
var Source = /** @class */ (function (_super) {
    __extends(Source, _super);
    function Source() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Source;
}(BackboneElement));
exports.Source = Source;
var EntityDetail = /** @class */ (function (_super) {
    __extends(EntityDetail, _super);
    function EntityDetail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EntityDetail;
}(BackboneElement));
exports.EntityDetail = EntityDetail;
var Entity = /** @class */ (function (_super) {
    __extends(Entity, _super);
    function Entity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Entity;
}(BackboneElement));
exports.Entity = Entity;
var Udi = /** @class */ (function (_super) {
    __extends(Udi, _super);
    function Udi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Udi;
}(BackboneElement));
exports.Udi = Udi;
var QuestionnaireResponse = /** @class */ (function (_super) {
    __extends(QuestionnaireResponse, _super);
    function QuestionnaireResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QuestionnaireResponse;
}(Resource));
exports.QuestionnaireResponse = QuestionnaireResponse;
var Questionnaire = /** @class */ (function (_super) {
    __extends(Questionnaire, _super);
    function Questionnaire() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Questionnaire;
}(Resource));
exports.Questionnaire = Questionnaire;
var Patient = /** @class */ (function (_super) {
    __extends(Patient, _super);
    function Patient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Patient;
}(Resource));
exports.Patient = Patient;
var DocumentReference = /** @class */ (function (_super) {
    __extends(DocumentReference, _super);
    function DocumentReference() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DocumentReference;
}(Resource));
exports.DocumentReference = DocumentReference;
var Appointment = /** @class */ (function (_super) {
    __extends(Appointment, _super);
    function Appointment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Appointment;
}(Resource));
exports.Appointment = Appointment;
var AppointmentResponse = /** @class */ (function (_super) {
    __extends(AppointmentResponse, _super);
    function AppointmentResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AppointmentResponse;
}(Resource));
exports.AppointmentResponse = AppointmentResponse;
var Organization = /** @class */ (function (_super) {
    __extends(Organization, _super);
    function Organization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Organization;
}(Resource));
exports.Organization = Organization;
var Location = /** @class */ (function (_super) {
    __extends(Location, _super);
    function Location() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Location;
}(Resource));
exports.Location = Location;
var Account = /** @class */ (function (_super) {
    __extends(Account, _super);
    function Account() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Account;
}(Resource));
exports.Account = Account;
var ProcessRequest = /** @class */ (function (_super) {
    __extends(ProcessRequest, _super);
    function ProcessRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProcessRequest;
}(Resource));
exports.ProcessRequest = ProcessRequest;
var Encounter = /** @class */ (function (_super) {
    __extends(Encounter, _super);
    function Encounter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Encounter;
}(Resource));
exports.Encounter = Encounter;
var CareTeamParticipant = /** @class */ (function (_super) {
    __extends(CareTeamParticipant, _super);
    function CareTeamParticipant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CareTeamParticipant;
}(BackboneElement));
exports.CareTeamParticipant = CareTeamParticipant;
var CareTeam = /** @class */ (function (_super) {
    __extends(CareTeam, _super);
    function CareTeam() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CareTeam;
}(Resource));
exports.CareTeam = CareTeam;
var EpisodeOfCare = /** @class */ (function (_super) {
    __extends(EpisodeOfCare, _super);
    function EpisodeOfCare() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EpisodeOfCare;
}(Resource));
exports.EpisodeOfCare = EpisodeOfCare;
var CarePlan = /** @class */ (function (_super) {
    __extends(CarePlan, _super);
    function CarePlan() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CarePlan;
}(Resource));
exports.CarePlan = CarePlan;
var Communication = /** @class */ (function (_super) {
    __extends(Communication, _super);
    function Communication() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Communication;
}(Resource));
exports.Communication = Communication;
var Task = /** @class */ (function (_super) {
    __extends(Task, _super);
    function Task() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Task;
}(Resource));
exports.Task = Task;
var ProcedureRequest = /** @class */ (function (_super) {
    __extends(ProcedureRequest, _super);
    function ProcedureRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProcedureRequest;
}(Resource));
exports.ProcedureRequest = ProcedureRequest;
var PractitionerRole = /** @class */ (function (_super) {
    __extends(PractitionerRole, _super);
    function PractitionerRole() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PractitionerRole;
}(Resource));
exports.PractitionerRole = PractitionerRole;
var Practitioner = /** @class */ (function (_super) {
    __extends(Practitioner, _super);
    function Practitioner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Practitioner;
}(Resource));
exports.Practitioner = Practitioner;
var Device = /** @class */ (function (_super) {
    __extends(Device, _super);
    function Device() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Device;
}(Resource));
exports.Device = Device;
var Observation = /** @class */ (function (_super) {
    __extends(Observation, _super);
    function Observation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Observation;
}(Resource));
exports.Observation = Observation;
var Immunization = /** @class */ (function (_super) {
    __extends(Immunization, _super);
    function Immunization() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Immunization;
}(Resource));
exports.Immunization = Immunization;
var CommunicationRequest = /** @class */ (function (_super) {
    __extends(CommunicationRequest, _super);
    function CommunicationRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CommunicationRequest;
}(Resource));
exports.CommunicationRequest = CommunicationRequest;
var AuditEvent = /** @class */ (function (_super) {
    __extends(AuditEvent, _super);
    function AuditEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AuditEvent;
}(Resource));
exports.AuditEvent = AuditEvent;
var Bundle = /** @class */ (function (_super) {
    __extends(Bundle, _super);
    function Bundle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Bundle;
}(Resource));
exports.Bundle = Bundle;
var HealthcareService = /** @class */ (function (_super) {
    __extends(HealthcareService, _super);
    function HealthcareService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HealthcareService;
}(Resource));
exports.HealthcareService = HealthcareService;
var Schedule = /** @class */ (function (_super) {
    __extends(Schedule, _super);
    function Schedule() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Schedule;
}(Resource));
exports.Schedule = Schedule;
